import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7394e8e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "com-table"
};
const _hoisted_2 = {
  class: "com-table-operation"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "com-title"
}, "详情-支付订单明细", -1));
const _hoisted_4 = {
  key: 0
};
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { columnsSingle } from '../data';
import { usePagination } from '@/hooks/usePagination';
import { useRoute, useRouter } from 'vue-router';
import { queryOrderDetailList } from '@/api/billBoardApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailPayTable',
  setup(__props) {
    const dataSource = ref([]);
    const loading = ref(false);
    const {
      pageTotal,
      pageIndex,
      pageSize,
      currentPageSizeChange
    } = usePagination(() => {
      initTableData();
    });
    const myRoute = useRoute();
    const myRouter = useRouter();
    const scrollY = ref(300);
    // 订单类型值过滤
    const getPayStatusText = computed(() => value => {
      return value == 20 ? '付款' : '退款';
    });
    const initTableData = async () => {
      try {
        let payStatus = 20;
        if (myRoute.query.type && myRoute !== null && myRoute !== void 0 && myRoute.query.type.includes('refund')) {
          payStatus = 30;
        } else if (myRoute.query.type && myRoute !== null && myRoute !== void 0 && myRoute.query.type.includes('pay')) {
          payStatus = 20;
        }
        loading.value = true;
        const params = {
          aggregateId: myRoute.query.aggregateId,
          payStatus,
          pageSize: pageSize.value,
          pageNum: pageIndex.value
        };
        const {
          code,
          data
        } = await queryOrderDetailList(params);
        if (code == '0') {
          dataSource.value = data.list;
          pageTotal.value = data.total;
        }
        loading.value = false;
      } catch (e) {}
    };
    // 动态更新 scrollY，比如根据窗口高度调整
    const updateScrollY = () => {
      const height = window.innerHeight; // 假设预留一些空间
      scrollY.value = height - 24 - 54 - 32 - 90 - 48 - 48;
    };
    onMounted(() => {
      updateScrollY();
      window.addEventListener('resize', updateScrollY);
      initTableData();
    });
    onUnmounted(() => {
      window.removeEventListener('resize', updateScrollY);
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_button, {
        onClick: _cache[0] || (_cache[0] = () => {
          _unref(myRouter).back();
        })
      }, {
        default: _withCtx(() => [_createTextVNode(" 返回 ")]),
        _: 1
      }), _hoisted_3]), _createVNode(_component_a_table, {
        columns: _unref(columnsSingle),
        "data-source": dataSource.value,
        loading: loading.value,
        scroll: {
          y: scrollY.value
        },
        bordered: "",
        pagination: false
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'payStatus' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(getPayStatusText)(record === null || record === void 0 ? void 0 : record.payStatus)), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "scroll"]), _createVNode(_component_a_pagination, {
        class: "com-table-pagination",
        total: _unref(pageTotal),
        "show-total": total => `共 ${total} 条`,
        current: _unref(pageIndex),
        "onUpdate:current": _cache[1] || (_cache[1] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        "show-size-changer": "",
        "page-size": _unref(pageSize),
        "onUpdate:page-size": _cache[2] || (_cache[2] = $event => _isRef(pageSize) ? pageSize.value = $event : null),
        onChange: _unref(currentPageSizeChange)
      }, null, 8, ["total", "show-total", "current", "page-size", "onChange"])]);
    };
  }
});